import moment from 'moment'
import _ from 'lodash'

const calculateReadyToPickUp = (order, timeSlot) => {
  const currentHour = Number(moment().format('HH'))

  const delayMinutesInOrder = _.get(order, 'item_preparation_status', 0)
  const storePreparation = _.get(order, 'restaurant.cooking_duration', 0)
  const distanceTravelPerMin = _.get(timeSlot, `[${currentHour}].distance_travel_per_min`, 0)
  const distanceToStore = _.get(timeSlot, `[${currentHour}].distance_to_store`, 0)
  const readyToPickUp = storePreparation - distanceToStore / distanceTravelPerMin

  const serverTime = Number(moment().format('x'))
  const createdOrderTime = Number(order.created_at)
  const remainingTime = parseInt(Number((serverTime - createdOrderTime) / 60000), 25)

  // eslint-disable-next-line no-bitwise
  return ((readyToPickUp - remainingTime) | 0) + delayMinutesInOrder
}

export default {
  calculateReadyToPickUp,
}



// WEBPACK FOOTER //
// ./src/utils/driver.js